// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_gh-a";
export var fulfillmentFormRail = "_gh-9";
export var headerTitleRow = "_gh-c";
export var orderDetailsWrapper = "_gh-7";
export var orderLinkTrigger = "_gh-2";
export var paymentInformationGrid = "_gh-h";
export var paymentSummaryColumn = "_gh-i";
export var shipmentContainer = "_gh-b";
export var shipmentDetailsMainPane = "_gh-8";
export var shipmentNavigationCard = "_gh-5";
export var shipmentNavigationRail = "_gh-3";
export var shipmentNavigationRailHeader = "_gh-4";
export var shipmentSummaryFact = "_gh-e";
export var shipmentSummaryGrid = "_gh-d";
export var shipmentSummaryMetadataRow = "_gh-f";
export var shipmentSummaryTags = "_gh-g";
export var shipmentWorkspace = "_gh-0";
export var shipmentWorkspaceContent = "_gh-6";
export var shipmentWorkspaceHeader = "_gh-1";